import {
  ICountryStrategy,
  ICountryFieldConfig,
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  FIELD_NIT,
  FIELD_COMMERCIAL_ADDRESS,
} from "../../interfaces/countryStrategy";
import { COUNTRY_COL, COUNTRY_COLOMBIA, ERRORS_MESSAGES } from "../../utils/constants";

const colombiaFields: ICountryFieldConfig[] = [
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  {
    ...FIELD_NIT,
    order: 4,
  },
  {
    ...FIELD_COMMERCIAL_ADDRESS,
    order: 5,
  },
];

export const colombiaStrategy: ICountryStrategy = {
  code: COUNTRY_COL,
  name: COUNTRY_COLOMBIA,
  fields: colombiaFields,

  getValidations: () => [
    {
      id: "userName",
      type: "required",
      message: ERRORS_MESSAGES.contactNameRequired,
    },
    {
      id: "name",
      type: "required",
      message: ERRORS_MESSAGES.nameRequired,
    },
    {
      id: "businessName",
      type: "required",
      message: ERRORS_MESSAGES.businessNameRequired,
    },
    {
      id: "cuit",
      type: "required",
      message: ERRORS_MESSAGES.nitRequired,
    },
    {
      id: "commercialAddress",
      type: "required",
      message: ERRORS_MESSAGES.commercialAddressRequired,
    },
  ],

  transformSubmitData: (data) => ({
    ...data,
    cuit: (data.cuit as string).replace(/[^0-9]/g, ""),
  }),
};
